import React from 'react';
import Layout from '../layouts/claire';
import { Link } from 'react-router';
import { preload, piece_block_info, sortFloors } from '../../helpers';
import { Animated } from 'react-animated-css';
import config from '../../config';
import moment from 'moment';
import BlackOverlay from '../partials/black_overlay';
import Menu from '../partials/menu';
import { Popover, PopoverBody, PopoverHeader, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import TopRightMenu from '../partials/top_right_menu';
import fakeAuth from '../../fakeAuth';
import LineLoader from '../partials/line_loader';
import _ from 'lodash';
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import DatePicker from 'react-datepicker';
import CustomDatePicker from './partials/custom_date_picker';
import See from './partials/see';
import Inventory from './partials/inventory';

class Housekeep extends React.Component {
    state = {
        menu_toggled: false,
        toggle: 0,
        rooms_selected: [],
        assigned_tasks: [],
        floors: [],
        status: config.room_status,
        hotel_name: localStorage.getItem('lb.ip') ? JSON.parse(localStorage.getItem('lb.ip')).Name : null,
        active_section: 0,
        blocking: false,
        block_reason: '',
        block_date_end: null,
    }
    componentWillMount() {
        const { params, booking_actions } = this.props;
        let user = fakeAuth.getUser();
        if (user.IdStaff && user.IdProperty !== params.id) this.props.router.goBack();
        else {
            this.props.properties_actions && this.props.properties_actions.fetch_one(params.id);
            this.props.floors_actions && this.props.floors_actions.fetch(params.id);
            this.props.staffs_actions && this.props.staffs_actions.fetch(params.id);
            booking_actions && booking_actions.fetch_range({
                IdProperty: params.id,
                CheckIn: moment().format('YYYY-MM-DD'),
                CheckOut: moment().add(1, 'day').format('YYYY-MM-DD')
            });
        }
    }
    componentWillReceiveProps = nextProps => {
        const { floors = [] } = nextProps;
        let user = fakeAuth.getUser();
        this.setState({ floors }, () => {
            // Here we count how many 'tasks' do I have assigned. 
            // IDEA: reduce the pieces on floors, and filter by those that contains my IdUser in the Staff array
            let my_rooms = _.chain(floors)
                .map(f => f.Pieces)
                .flattenDeep()
                .filter(piece => _.find(piece.Staff, s => s.IdStaff === user.IdStaff))
                .value();
            this.setState({ assigned_tasks: my_rooms });
        });
        // Setting auto-complete
        const { staffs } = nextProps;
        this.setState({
            staffs: _.chain(staffs || []).map(u => {
                return {
                    id: u.IdStaff,
                    name: `${u.FirstName} ${u.LastName}`
                }
            }).value()
        });

        // Bookings to set up occupied or not
        const { bookings } = nextProps;
        if (bookings) {
            this.setState({
                pieces_taken: _.chain(bookings)
                    .map(b => b.Rooms || [])
                    .flattenDeep()
                    .filter(r => r.IdPiece)
                    .map(p => p.IdPiece)
                    .value()
            });
        }
    }

    onAssignStaff = () => {
        const { selected_staff, rooms_selected, floors } = this.state, { params } = this.props;

        // TODO: not in love with this n3 alg
        floors.forEach(floor => {
            floor.Pieces.forEach(piece => {
                if (!piece.Staff) piece.Staff = [];
                if (_.chain(rooms_selected).map(r => r.IdPiece).value().indexOf(piece.IdPiece) !== -1) {
                    if (!_.find(piece.Staff, s => s.IdStaff === selected_staff.IdStaff)) {
                        piece.Staff.push(selected_staff);
                        // call API
                        this.props.floors_actions && this.props.floors_actions.assign_staff({
                            IdPiece: piece.IdPiece,
                            IdStaff: selected_staff.IdStaff,
                            IdProperty: params.id
                        });
                    }
                }
            });
        });

        this.setState({ selected_staff: null, assigning: false, floors });
    }
    onSaveStaff = () => {
        const { managing_piece_staff, managing_staff } = this.state, { params } = this.props;
        managing_staff.filter(u => !u.selected).forEach(u => {
            // call API
            this.props.floors_actions && this.props.floors_actions.unassign_staff({
                IdPiece: managing_piece_staff.IdPiece,
                IdStaff: u.IdStaff,
                IdProperty: params.id
            });
        });
        this.setState({ managing_staff: false, managing_piece_staff: false });

    }
    onHandleStaff = (piece) => {
        const me = fakeAuth.getUser();
        // Only admins can unassign
        if (me.Permissions & (config.permissions.SuperAdmin | config.permissions.Admin) === 0) return;
        // Enrich staff        
        piece.Staff.forEach(s => {
            s.name = _.find(this.state.staffs, t => t.id === s.IdStaff)?.name;
            s.selected = true;
        });
        this.setState({ managing_staff: [...piece.Staff], managing_piece_staff: piece });
    }
    onBounceStaff = (i) => {
        const { managing_staff } = this.state;
        managing_staff[i].bounce = !managing_staff[i].bounce;
        managing_staff[i].selected = !managing_staff[i].selected;
        this.setState({ managing_staff });
    }
    onBounce = (i) => {
        const { status } = this.state;
        const target = _.chain(status).reject(s => s.macro).value()[i];

        // 'No disponible' (fuera de servicio) exige motivo y fecha estimada de solucion,
        // asi que en vez de prender el bit de una, pedimos los datos primero.
        if (target.requires_reason && !target.selected) {
            this.setState({
                blocking: true,
                block_status_index: i,
                block_reason: '',
                block_date_end: null
            });
            return;
        }

        this.applyStatus(i);
    }

    onConfirmBlock = () => {
        const { block_status_index, block_reason, block_date_end, rooms_selected } = this.state, { params } = this.props;
        if (!block_reason || !block_reason.trim() || !block_date_end) return;

        // Guardamos motivo y fecha en cada pieza seleccionada, y luego prendemos el estatus
        rooms_selected.forEach(piece => {
            piece.BlockReason = block_reason.trim();
            piece.BlockDateEnd = block_date_end.format();
            this.props.floors_actions && this.props.floors_actions.update_piece_block(piece);
        });

        this.setState({ blocking: false }, () => this.applyStatus(block_status_index));
    }

    applyStatus = (i) => {
        const { status, rooms_selected } = this.state;

        _.chain(status).reject(s => s.macro).value()[i].bounce = true;
        _.chain(status).reject(s => s.macro).value()[i].selected = !_.chain(status).reject(s => s.macro).value()[i].selected;

        // TURN ON
        if (_.chain(status).reject(s => s.macro).value()[i].selected) {
            rooms_selected.forEach(piece => {
                if (!(piece.Status & Math.pow(2, _.chain(status).reject(s => s.macro).value()[i].id - 1))) {
                    piece.Status += Math.pow(2, _.chain(status).reject(s => s.macro).value()[i].id - 1);
                    this.props.floors_actions && this.props.floors_actions.update_piece_status(piece);
                }
            });

        } else {
            // TURN OFF
            const target = _.chain(status).reject(s => s.macro).value()[i];
            rooms_selected.forEach(piece => {
                if ((piece.Status & Math.pow(2, target.id - 1))) {
                    piece.Status -= Math.pow(2, target.id - 1);
                    this.props.floors_actions && this.props.floors_actions.update_piece_status(piece);
                }
                // Al reactivar la habitacion, limpiamos motivo y fecha del bloqueo
                if (target.requires_reason) {
                    piece.BlockReason = null;
                    piece.BlockDateEnd = null;
                    this.props.floors_actions && this.props.floors_actions.update_piece_block(piece);
                }
            });
        }

        this.setState({ status, rooms_selected }, () => {
            setTimeout(() => {
                _.chain(status).reject(s => s.macro).value()[i].bounce = false;
                this.setState({ status });
            }, 1000);
        });
    }


    renderHeader = () => {
        const { active_section } = this.state;
        return <div className="d-flex">
            <div className="w-100 d-flex">
                <i className="icon-lb_housekeep blue font-40 align-self-center" />
                <div className="align-self-center d-flex flex-column ms-3">
                    <span className="white font-20 line1 poppins">Housekeeping</span>
                    <Link to="/properties" className="white font-10 poppins underlined">{this.state.hotel_name}</Link>
                </div>
                <div className="ms-4 d-flex align-self-center" style={{ gap: 8 }}>
                    <button onClick={() => this.setState({ active_section: 0 })}
                        className={`btn btn-sm poppins font-10 ${active_section === 0 ? 'btn-blue white' : 'btn-gray-2 gray'}`}
                        style={{ borderRadius: 20 }}>
                        <i className="fas fa-bed me-1" />Habitaciones
                    </button>
                    <button onClick={() => this.setState({ active_section: 1 })}
                        className={`btn btn-sm poppins font-10 ${active_section === 1 ? 'btn-blue white' : 'btn-gray-2 gray'}`}
                        style={{ borderRadius: 20 }}>
                        <i className="fas fa-boxes me-1" />Inventario
                    </button>
                </div>
            </div>
            <div className="d-flex align-self-center w-100">
                <TopRightMenu {...this.props} />
            </div>
        </div>
    }
    renderControls = () => {
        const { status, assigned_tasks } = this.state;
        return <div className="px-4 py-3 d-flex" style={{ background: '#15191E' }}>
            <i className="ms-2 blue far font-20 fa-calendar align-self-center" />
            <span className="poppins white font-30 ms-2 align-self-center">{moment().locale('es').format('DD')}</span>
            <div className="d-flex flex-column ms-2 align-self-center">
                <span className="poppins white font-8 toUpper">{moment().locale('es').format('MMMM')}</span>
                <span className="poppins white font-8">{moment().locale('es').format('YYYY')}</span>
            </div>
            <i className="ms-4 white fas font-20 fa-chevron-right align-self-center" />
            <div onClick={() => {
                this.setState({ filter_assigned_tasks: !this.state.filter_assigned_tasks });
            }} className={`ms-4 bg-${this.state.filter_assigned_tasks ? 'green' : 'blue'} d-flex flex-row justify-content-center pointer zoomable`} style={{ width: 50, height: 50, borderRadius: 25, border: '6px solid black' }}>
                <span className="white font-14 poppins align-self-center">{assigned_tasks.length}</span>
            </div>
            <div className="d-flex flex-column ms-2 align-self-center">
                <span className="poppins white font-8">Tareas</span>
                <span className="poppins white font-8">Pendientes</span>
            </div>
            <button className="btn btn-link ms-auto d-flex" id="btn-estados" onClick={() => this.setState({ states_menu: !this.state.states_menu })}>
                <i className="fas fa-circle green font-8 me-2 align-self-center" />
                <span className="gray align-self-center font-16 poppins">Estados</span>
                <i className="ms-2 gray fas font-12 fa-chevron-down align-self-center" />
            </button>
            <Popover placement="bottom" isOpen={this.state.states_menu} target={`btn-estados`} toggle={() => this.setState({ states_menu: !this.state.states_menu })} className="bg-gray-2">
                <PopoverBody className="d-flex flex-column justify-content-center">
                    {status.map((s, i) => <button key={i} className="btn btn-link btn-sm white text-left"><i className="fas fa-circle font-8 me-2" style={{ color: s.color }} />{s.name}</button>)}
                </PopoverBody>
            </Popover>
        </div>
    }
    renderAccordion = () => {
        const { toggle, floors, status, assigned_tasks } = this.state;
        let user = fakeAuth.getUser();
        let OCUPADA = config.room_status[3];
        return <section>
            <div className="bg-gray-2 d-flex black-input mb-3 mt-4" style={{ overflow: 'hidden' }}>
                <div className="w-100">
                    {this.renderControls()}
                    {floors && floors.length > 0 && sortFloors(floors).map((floor, floor_index) => {
                        return (<section key={floor.IdFloor || floor.TemporalId}>

                            {/* FLOOR HEADER */}
                            <div className="px-4 py-3 d-flex pointer" onClick={() => this.setState({ toggle: floor_index }, () => {
                                // NEW: if we change floors, we clean up the selection and the status
                                const { status } = this.state;
                                status.forEach(s => s.selected = false);
                                this.setState({ status, rooms_selected: [] });
                            })}>
                                <span className="poppins white align-self-center">Piso {floor.Label}</span>
                                <i className={`ms-2 blue fas fa-chevron-${toggle === floor_index ? 'down' : 'right'} align-self-center`} />


                                {this.state.filter_assigned_tasks && _.find(assigned_tasks, at => at.IdFloor === floor.IdFloor) && <div className="ms-auto d-flex">
                                    <div className={`ms-4 bg-${this.state.filter_assigned_tasks ? 'green' : 'blue'} d-flex flex-row justify-content-center pointer zoomable`} style={{ width: 40, height: 40, borderRadius: 20, border: '6px solid black' }}>
                                        <span className="white font-12 poppins align-self-center">{_.filter(assigned_tasks, at => at.IdFloor === floor.IdFloor).length}</span>
                                    </div>
                                    <div className="d-flex flex-column ms-2 align-self-center">
                                        <span className="poppins white font-8">Tareas</span>
                                        <span className="poppins white font-8">Pendientes</span>
                                    </div>
                                </div>}

                            </div>
                            {/* PIECES */}
                            {toggle === floor_index && <div className="bg-black p-4 d-flex flex-wrap justify-content-center">

                                {_.chain(floor.Pieces)
                                    .filter(piece => {
                                        if (this.state.filter_assigned_tasks) {
                                            return _.find(piece.Staff, s => s.IdStaff === user.IdStaff) ? true : false
                                        }
                                        return true;
                                    })
                                    .value().map((piece, b) => <figure className={`pointer bg-gray-2 d-flex flex-column black-input m-1 p-2 ${_.find(this.state.rooms_selected, r => r.IdPiece === piece.IdPiece) ? 'white-border' : ''}`} style={{ width: 235 }} key={b} onClick={() => {
                                        /* 
                                        IF ADMIN -> SET THE ROOM AS SELECTED
                                        IF STAFF -> SEE
                                        */
                                        const user = fakeAuth.getUser();
                                        if (user.IdStaff) {
                                            this.setState({ watch_room: piece, seeing: true }, () => {
                                                this.props.floors_actions.fetch_comments(this.state.watch_room.IdPiece);
                                            });
                                        } else {
                                            const { rooms_selected, status, pieces_taken } = this.state;
                                            // Set the array of status pre-selected to the current status of this piece?
                                            status.forEach(s => {
                                                if (!status.selected && Math.pow(2, s.id - 1) & piece.Status) s.selected = true;
                                            });
                                            if (_.find(rooms_selected, r => r.IdPiece === piece.IdPiece)) {
                                                this.setState({
                                                    status,
                                                    rooms_selected: _.reject(rooms_selected, r => r.IdPiece === piece.IdPiece)
                                                }, () => {
                                                    // If there are no more pieces selected, clean up the status
                                                    if (!this.state.rooms_selected.length) {
                                                        status.forEach(s => {
                                                            s.selected = false;
                                                        });
                                                        this.setState({ status });
                                                    }
                                                });
                                            } else {
                                                this.setState({
                                                    status,
                                                    rooms_selected: [...rooms_selected, piece]
                                                });
                                            }
                                        }
                                    }}>
                                        <div className="d-flex w-100">

                                            {/* VER */}
                                            <div className="d-flex" onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                this.setState({ watch_room: piece, seeing: true }, () => {
                                                    this.props.floors_actions.fetch_comments(this.state.watch_room.IdPiece);
                                                });
                                            }} >
                                                <i className="fas fa-eye white font-10 align-self-center"></i>
                                                <span className="white font-10 align-self-center ms-1 poppins">Ver</span>
                                            </div>

                                            {/* STAFF ASSIGNED TO THIS PIECE */}
                                            {(piece.Staff || []).length > 0 && <span onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                this.onHandleStaff(piece);
                                            }}
                                                className={`ms-auto ${_.find(piece.Staff, s => s.IdStaff === user.IdStaff) ? 'green' : 'white'} font-10 align-self-center poppins`}><i className="icon-lb_staff font-10 me-1"></i>{(piece.Staff || []).length}</span>}

                                            {/* SELECTED */}
                                            <i className={`ms-auto ${_.find(this.state.rooms_selected, r => r.IdPiece === piece.IdPiece) ? 'fas fa-circle green' : 'far fa-circle white'} font-10 align-self-center ms-1`}></i>
                                        </div>

                                        {/* LABEL */}
                                        < div className="d-flex w-100 justify-content-center" style={{ height: 80 }}>
                                            <span className="white font-10 align-self-center mx-2 poppins">{piece.Label}</span>
                                        </div>

                                        {/* FUERA DE SERVICIO */}
                                        {(() => {
                                            const block = piece_block_info(piece);
                                            if (!block || !block.blocked) return null;
                                            return <div className="d-flex flex-column w-100 mb-1">
                                                <span className="red font-8 poppins line1"><i className="fas fa-warning me-1" />Fuera de servicio</span>
                                                {block.reason && <span className="gray font-8 poppins line1">{block.reason}</span>}
                                                <span className="gray font-8 poppins line1">{block.until_label ? `Hasta ${block.until_label}` : 'Sin fecha estimada'}</span>
                                            </div>
                                        })()}

                                        {/* STATUS */}
                                        <div className="d-flex w-100">
                                            {status.map((s, index) => {
                                                if (piece.Status & Math.pow(2, s.id - 1)) {
                                                    return (<i key={index} className="me-1 fas fa-circle font-10 align-self-center" title={s.name} style={{ color: s.color }}></i>)
                                                } else return null
                                            })}
                                            {this.state.pieces_taken && this.state.pieces_taken.indexOf(piece.IdPiece) !== -1
                                                && <i className="me-1 fas fa-circle font-10 align-self-center" title={OCUPADA.name} style={{ color: OCUPADA.color }}></i>}
                                            <span className="white font-10 align-self-center ms-1 poppins">Estados</span>
                                        </div>
                                    </figure>)
                                }
                            </div>}
                        </section>)
                    })
                    }
                </div >
            </div >
        </section >
    }
    renderCommon = () => {
        const { active_section } = this.state;
        return (
            <div className="">
                {this.renderHeader()}
                {active_section === 0 ? this.renderAccordion() : <Inventory {...this.props} />}
                <div style={{ height: 200 }} />
            </div>
        )
    }


    render() {
        const form = this.props.form_actions;
        const { rooms_selected, status } = this.state;
        return (
            <Layout router={this.props.router} nbs="home" title="legendbeds" form={this.props.form} form_actions={this.props.form_actions}>
                <section>

                    {this.state.microTransac && <LineLoader />}

                    {/* DESKTOP */}
                    <div className="w3-container w3-hide-small " style={{ marginLeft: 100 }}>
                        <div style={{ height: 50 }} />
                        {this.renderCommon()}
                    </div>
                    {/* MOBILE */}
                    <div className="w3-container w3-hide-medium w3-hide-large">
                        <div style={{ height: 65 }} />
                        {this.renderCommon()}
                    </div>

                    <Menu {...this.state} {...this.props} />

                    {/* SELECCION DE ESTADOS */}
                    <Animated animationInDuration={300} animationOutDuration={300} isVisible={rooms_selected.length ? true : false} animateOnMount={false} animationIn="slideInUp" animationOut="slideOutDown" style={{ position: 'fixed', bottom: 0, left: 100, right: 0 }} className="p-4 d-flex justify-content-center">
                        <div className="black-input p-4 d-flex" style={{ backgroundColor: '#15191E' }}>
                            <div className="align-self-center">
                                <div className="d-flex">
                                    <span className="font-8 gray">Seleccionados:</span>
                                    <span className="font-8 ms-2 blue">{_.chain(rooms_selected)
                                        .map(r => r.Label).value().join(', ')}</span>
                                </div>
                                <div className="d-flex my-2">
                                    <div className="bg-gray-light w-100 align-self-center" style={{ height: 1 }}></div>
                                    <span className="gray font-8 w-75 align-self-center text-center anton">SELECCIONE ESTADOS</span>
                                    <div className="bg-gray-light w-100 align-self-center" style={{ height: 1 }}></div>
                                </div>
                                <div className="d-flex justify-content-evenly align-items-start">
                                    {_.chain(status).reject(s => s.macro).value().map((s, i) => <div onClick={() => this.onBounce(i)} key={i} className={`w-100 d-flex flex-column justify-content-center text-center ${s.bounce ? 'bounce' : ''}`}>
                                        <button className={`btn btn-lg btn-${s.selected ? 'blue white' : 'gray-light black'} align-self-center`} style={{ borderRadius: 5 }}><i className={`${s.icon}`} /></button>
                                        <span className="font-8 white poppins mt-1 gray align-self-center">{s.name}</span>
                                    </div>)}
                                </div>
                            </div>
                            <div className="d-flex flex-column align-self-center ms-4">
                                <button onClick={() => this.setState({ assigning: true, selected_staff: null })} type="button" className="btn btn-lg btn-gray-light black w-100 poppins font-10">
                                    Asignar <i className="icon-lb_user" />
                                </button>
                                <button onClick={() => {
                                    this.setState({ watch_room: _.first(rooms_selected), seeing: true }, () => {
                                        this.props.floors_actions.fetch_comments(this.state.watch_room.IdPiece);
                                    });
                                }} type="button" className="btn btn-lg btn-black gray w-100 mt-2 poppins font-10">
                                    Ver <i className="fas fa-eye" />
                                </button>
                            </div>
                        </div>

                    </Animated>

                    {/* Assign */}
                    <Animated animateOnMount={false} animationIn='fadeIn' animationInDuration={200} animationOutDuration={200} animationOut='fadeOut' isVisible={this.state.assigning ? true : false}>
                        <BlackOverlay />
                        <div className="d-flex justify-content-center" style={{ position: 'fixed', top: 0, bottom: 0, left: 100, right: 0, zIndex: 1 }}>
                            <div className="black-input bg-gray-2 p-4 align-self-center">
                                <h3 className="white poppins text-center line1">Asignar tareas</h3>
                                <h6 className="blue text-center poppins font-10 line1">Habitaciones: {_.chain(rooms_selected)
                                    .map(r => r.Label).value().join(', ')}</h6>
                                <hr className="w-50 mx-auto" />
                                <div className="d-flex flex-row">
                                    <span className="white mt-2 me-2">Tareas:</span>
                                    {_.chain(status).reject(s => s.macro).filter(s => s.selected).value().map((s, i) => <div key={i} className={`d-flex align-self-start flex-column justify-content-center text-center`} style={{ width: 70 }}>
                                        <div className={`btn btn-lg btn-${false ? 'blue white' : 'gray-light black'} align-self-center`} style={{ borderRadius: 5 }}><i className={`${s.icon}`} /></div>
                                        <span className="font-8 white poppins mt-1 gray align-self-center">{s.name}</span>
                                    </div>)}
                                </div>
                                <div className="w-100 mt-4">
                                    <label className="white poppins font-12">Encargar a <i className="blue">*</i></label>
                                    <div style={{ width: 400 }} className={`${false ? 'error-input' : ''} d-flex mt-2`}>
                                        <ReactSearchAutocomplete
                                            className="w-100 white"
                                            styling={{
                                                height: "44px",
                                                border: "2px solid #343f4b",
                                                borderRadius: "12px",
                                                backgroundColor: "#0e1115",
                                                boxShadow: "rgba(32, 33, 36, 0.28) 0px 1px 6px 0px",
                                                hoverBackgroundColor: "#343F4B",
                                                color: "white",
                                                fontSize: "16px",
                                                iconColor: "#9a9a9a",
                                                placeholderColor: "white",
                                                clearIconMargin: '3px 14px 0 0',
                                                searchIconMargin: '0 0 0 16px'
                                            }}
                                            items={this.state.staffs || []}
                                            onSearch={() => { }}
                                            onHover={() => { }}
                                            onSelect={({ id, name }) => {
                                                this.setState({ selected_staff: _.find(this.props.staffs, s => s.IdStaff === id) });
                                            }}
                                            onFocus={() => { }}
                                            autoFocus
                                            formatResult={(item) => {
                                                return (
                                                    <div>
                                                        <span style={{ display: 'block', textAlign: 'left' }}>{item.name}</span>
                                                    </div>
                                                )
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center mt-4">
                                    <button onClick={() => this.setState({ assigning: false })} type="button" className="btn btn-lg btn-gray-2 white ms-3 align-self-center" >
                                        <i className="fas fa-times white font-12" />
                                    </button>
                                    <button onClick={this.onAssignStaff} type="button" className={`btn btn-lg btn-${this.state.selected_staff ? 'blue' : 'gray-2'} white ms-3 align-self-center`} >
                                        <i className="fas fa-check white font-12" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Animated>

                    {/* Fuera de servicio: motivo + fecha estimada de solucion */}
                    <Animated animateOnMount={false} animationIn='fadeIn' animationInDuration={200} animationOutDuration={200} animationOut='fadeOut' isVisible={this.state.blocking ? true : false}>
                        {this.state.blocking && <section>
                            <BlackOverlay />
                            <div className="d-flex justify-content-center" style={{ position: 'fixed', top: 0, bottom: 0, left: 100, right: 0, zIndex: 1 }}>
                                <div className="black-input bg-gray-2 p-4 align-self-center" style={{ width: 520 }}>
                                    <h3 className="white poppins text-center line1"><i className="fas fa-warning red me-2" />Fuera de servicio</h3>
                                    <h6 className="blue text-center poppins font-10 line1 mt-2">Habitaciones: {_.chain(rooms_selected).map(r => r.Label).value().join(', ')}</h6>
                                    <p className="gray poppins font-8 text-center mt-2 mb-0">
                                        La habitación no podrá asignarse a reservas hasta el día siguiente de la fecha estimada.
                                    </p>
                                    <hr className="w-50 mx-auto" />

                                    <div className="w-100">
                                        <label className="white poppins font-12">Motivo <i className="blue">*</i></label>
                                        <div className={`black-input ${this.state.block_dirty && !this.state.block_reason.trim() ? 'error-input' : ''} d-flex mt-2`}>
                                            <input className="w-100 p-3 white" type="text" placeholder="Ej: Aire acondicionado dañado"
                                                value={this.state.block_reason}
                                                onChange={e => this.setState({ block_reason: e.target.value, block_dirty: true })} />
                                        </div>
                                    </div>

                                    <div className="w-100 mt-3">
                                        <label className="white poppins font-12">Fecha estimada de solución <i className="blue">*</i></label>
                                        <div className="mt-2">
                                            <DatePicker selected={this.state.block_date_end} minDate={moment()}
                                                customInput={<CustomDatePicker format="DD/MM/YYYY" hint="Seleccione" />}
                                                showYearDropdown scrollableYearDropdown yearDropdownItemNumber={5}
                                                onChange={date => this.setState({ block_date_end: moment(date).utc(), block_dirty: true })}
                                                className={`white font-12 ${this.state.block_date_end ? 'dirty' : ''}`} />
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-center mt-4">
                                        <button onClick={() => this.setState({ blocking: false, block_dirty: false })} type="button" className="btn btn-lg btn-gray-2 white ms-3 align-self-center">
                                            <i className="fas fa-times white font-12" />
                                        </button>
                                        <button onClick={this.onConfirmBlock} type="button"
                                            className={`btn btn-lg btn-${(this.state.block_reason.trim() && this.state.block_date_end) ? 'blue' : 'gray-2'} white ms-3 align-self-center`}>
                                            <i className="fas fa-check white font-12" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </section>}
                    </Animated>

                    {/* Ver */}
                    <Animated animateOnMount={false} animationIn='fadeIn' animationInDuration={200} animationOutDuration={200} animationOut='fadeOut' isVisible={this.state.seeing ? true : false}>
                        <BlackOverlay />
                        <div className="d-flex justify-content-center" style={{ position: 'fixed', top: 0, bottom: 0, left: 100, right: 0, zIndex: 1 }}>
                            <div className="black-input bg-gray-2 align-self-center" style={{ overflow: 'hidden' }}>
                                <See {...this.props} room={this.state.watch_room} toggle={() => this.setState({ seeing: !this.state.seeing })} />
                            </div>
                        </div>
                    </Animated>

                    {/* Unassign */}
                    <Animated animationInDuration={300} animationOutDuration={300} isVisible={this.state.managing_staff?.length ? true : false} animateOnMount={false} animationIn="slideInUp" animationOut="slideOutDown" style={{ position: 'fixed', bottom: 0, left: 100, right: 0 }} className="p-4 d-flex justify-content-center">
                        <div className="black-input p-4 d-flex" style={{ backgroundColor: '#15191E' }}>
                            <div className="align-self-center">
                                <div className="d-flex my-2">
                                    <div className="bg-gray-light w-100 align-self-center" style={{ height: 1 }}></div>
                                    <span className="gray font-8 w-100 align-self-center text-center">Staff asignado</span>
                                    <div className="bg-gray-light w-100 align-self-center" style={{ height: 1 }}></div>
                                </div>
                                <div className="d-flex justify-content-evenly align-items-start">
                                    {_.chain(this.state.managing_staff || []).value().map((s, i) => <div onClick={() => this.onBounceStaff(i)} key={i} className={`w-100 d-flex flex-column justify-content-center text-center ${s.bounce ? 'bounce' : ''}`}>
                                        <button className={`btn btn-lg btn-${s.selected ? 'blue white' : 'gray-light black'} align-self-center`} style={{ borderRadius: 5 }}><i className={`icon-lb_user`} /></button>
                                        <span className="font-8 white poppins mt-1 gray align-self-center">{s.name || 'Freddy'}</span>
                                    </div>)}
                                </div>
                            </div>
                            <div className="d-flex flex-column align-self-center">
                                <button onClick={this.onSaveStaff} type="button" className="btn btn-lg btn-gray-light black w-100 poppins font-10">
                                    Guardar <i className="fas fa-check" />
                                </button>
                            </div>
                        </div>

                    </Animated>


                </section>
            </Layout>
        )
    }
}

export default Housekeep;
